import { hostname } from "../../providers/api";

export const carbonRequest = async (accessToken, path, options = {}) => {
  const response = await fetch(`${hostname}/${path}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      ...(typeof options.body === "string"
        ? { "Content-Type": "application/json" }
        : {}),
      ...(options.headers || {}),
    },
  });
  const body = await response.json().catch(() => ({}));

  if (!response.ok) {
    const rawMessage = body.message || body.code || "Carbon request failed";
    const error = new Error(
      Array.isArray(rawMessage) ? rawMessage.join(". ") : rawMessage,
    );
    error.status = response.status;
    error.code =
      body.code ||
      (typeof body.message === "string" && body.message.startsWith("CARBON_")
        ? body.message
        : undefined);
    error.details = body;
    throw error;
  }

  return body;
};
